export default __webpack_public_path__ + "static/media/100_42390.b1d557e8.jpg";